require('es6-shim');
window._ = require('lodash');
require('./components/filters')

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');
require('bootstrap-daterangepicker');
require('bootstrap-sass');

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue').default;
require('vue-resource');

window.Vuex = require('vuex');
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios').default;

window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': window.Portal.csrfToken,
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json'
};

/**
 * We'll register a HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 * included with Laravel will automatically verify the header's value.
 *
 * We need this until everthing is transitioned to axios
 */

Vue.http.interceptors.push((request, next) => {
    request.headers.set('X-CSRF-TOKEN', Laravel.csrfToken);

    next();
});

/**
 * Register libraries
 */
require('jquery-mask-plugin');
require('toastr');
window.swal = window.sweetAlert = require('sweetalert2');
window.moment = require('moment');
